import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-shell" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "form-actions" }

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import VendorDashboardHeader from "@/modules/vendor/components/VendorDashboardHeader.vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";
import AppTextArea from "@/shared/components/ui/AppTextArea.vue";
import AppButtonFlat from "@/shared/components/ui/AppButtonFlat.vue";
import { useSnackbarStore } from "@/shared/stores/snackbar";
import { saveQuotationTemplate } from "@/modules/vendor/services/quotation-templates.api";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuotationFormPage',
  props: {
    templateId: {}
  },
  setup(__props: any) {

const router = useRouter();
const snackbar = useSnackbarStore();

const props = __props;

const quotationData = ref({
  name: "",
  description: "",
});

const isSubmitting = ref(false);

const isValid = computed(() => {
  return Boolean(quotationData.value.name);
});

async function handleSubmit() {
  if (isSubmitting.value || !isValid.value) return;

  isSubmitting.value = true;

  try {
    const payload: Record<string, any> = {
      id: props.templateId ?? null,
      name: quotationData.value.name,
      description: quotationData.value.description || null,
      is_active: true,
    };

    const response = await saveQuotationTemplate(payload);
    const templateId =
      response?.data?.id ??
      response?.id ??
      response?.data?.template?.id ??
      response?.template?.id;

    if (!templateId) {
      throw new Error("Template ID missing from saveQuotationTemplate response.");
    }

    router.back();
  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      "Unable to create quotation.";
    snackbar.error(message);
  } finally {
    isSubmitting.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VendorDashboardHeader, { title: "Create Quotation" }),
    _createElementVNode("div", null, [
      _createVNode(_component_v_form, {
        onSubmit: _withModifiers(handleSubmit, ["prevent"]),
        class: "quotation-form"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(AppTextField, {
              modelValue: quotationData.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quotationData.value.name) = $event)),
              label: "Name",
              placeholder: "Template Name",
              required: ""
            }, null, 8, ["modelValue"])
          ]),
          _createVNode(AppTextArea, {
            modelValue: quotationData.value.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((quotationData.value.description) = $event)),
            label: "Description",
            placeholder: "Enter template description...",
            rows: "2",
            required: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(AppButtonFlat, {
              type: "submit",
              color: "primary",
              "prepend-icon": "mdi-check",
              loading: isSubmitting.value,
              disabled: isSubmitting.value || !isValid.value,
              block: ""
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Create ", -1)
              ]))]),
              _: 1
            }, 8, ["loading", "disabled"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})